import { darken } from '@mui/material/styles';
export const MuiFab = (theme) => ({
    styleOverrides: {
        default: {
            background: '#fff',
            '&:hover': {
                background: darken('#fff', 0.15)
            }
        },
        secondary: {
            color: theme.palette.primary.main,
            '&:hover': {
                color: theme.palette.primary.dark
            }
        }
    }
});
